export default {"src":"/_next/static/media/my_products.d1c9e946.svg","height":48,"width":40};